<template>
  <input class="input-text" :class="classes" :value="value" v-bind="$attrs" v-on="listeners" />
</template>

<script>
/**
 * テキスト入力
 *
 * `<input type="text">` をラップしており、その全ての props を使用できます
 */
export default {
  name: 'TextInput',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    /** 入力値 (v-model) */
    value: [String, Number],
    /** 入力エリアの大きさ */
    size: {
      required: false,
      type: String,
      default: '',
      validate: size => ['large'].includes(size),
    },
    /** エラー表示 */
    error: Boolean,
  },
  computed: {
    classes() {
      return {
        isError: this.error,
        [this.size]: !!this.size,
      }
    },
    listeners() {
      return {
        ...this.$listeners,
        input: e => {
          /**
           * 文字入力
           * @event input
           * @type {string}
           */
          this.$emit('input', e.target.value)
        },
        change: e => {
          /**
           * 値変更
           * @event change
           * @type {string}
           */
          this.$emit('change', e.target.value)
        },
        compositionstart: () => {
          this.$emit('compositionstart')
        },
        compositionend: e => {
          this.$emit('compositionend', e)
        },
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.input-text {
  appearance: none;
  background-color: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--text-color);
  font-size: 15px;
  height: 40px;
  opacity: 1;
  outline: 0;
  padding: 0 16px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  width: 100%;

  &.large {
    font-size: 30px;
    font-weight: 600;
    height: 48px;
    letter-spacing: 1.5px;
    padding: 8px;
  }

  &:focus {
    border: 1px solid var(--dark-gray);
  }

  &:disabled {
    background-color: var(--mostly-white-1);
    -webkit-text-fill-color: var(--text-color);
  }

  &::placeholder {
    color: var(--dark-gray);
    -webkit-text-fill-color: var(--dark-gray);
  }

  &.isError {
    background: #fff3f0;
    border-color: var(--pure-red);
  }
}
</style>
